import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { IImage } from '../../../../../common/model/ICarDetails';
import carConfigurationSelectors from '../../../../store/selectors/carConfigurationSelectors';
import VariantSlider from '../../../../../common/components/variantSlider/VariantSlider';
import { ICarDetails } from '../../../../../../../common/model/ICarDetails';
import optionsSelectors from '../../../../store/selectors/optionsSelectors';
import currentDealSelectors from '../../../../store/selectors/currentDealSelectors';
import SliderTitleOfferContainer from '../variantSlider/sliderTitleOffer/SliderTitleOfferContainer';
import { getVariantDetails } from '../../../../store/selectors/variantDetailsSelectors';
import MarketingLabel from '../../../../../common/components/marketingLabel/MarketingLabel';
import useIsMobile from '../../../../../common/react/useIsMobile';
import { Box } from '@material-ui/core';
import { ImageType } from '../../../../../../../common/enum/ImageType';
import { getCustomiseSelectedSection } from '../../../../store/selectors/customiseSelectors';

interface ISearchImage {
  carConfigProperty: keyof ICarDetails;
  type?: string;
}

// TODO: Add other images to be searched during INCHD-7609
const imagesEnum: ISearchImage[] = [
  { carConfigProperty: 'exteriorColour', type: ImageType.FRONT },
  { carConfigProperty: 'exteriorColour', type: ImageType.REAR },
  { carConfigProperty: 'interiorImage' },
];

const extractSliderImages = (carConfig: ICarDetails): IImage[] =>
  imagesEnum.reduce((images: IImage[], imageSearch) => {
    let image: IImage | null =
      imageSearch.carConfigProperty === 'interiorImage'
        ? carConfig.interiorImage ?? null
        : extractImage(carConfig[imageSearch.carConfigProperty]?.images, imageSearch.type);

    if (image?.url) {
      if (!image.type) {
        image = {
          ...image,
          type: ImageType.INTERIOR,
        };
      }

      images.push(image);

      return images;
    }

    return images;
  }, []);

const extractImage = (images: IImage[], type: string): IImage | null =>
  images?.find((image: IImage) => image?.type?.toLowerCase() === type.toLowerCase()) || null;

const VariantSliderContainer: FunctionComponent = () => {
  const carConfig: ICarDetails = useSelector(carConfigurationSelectors.getConfiguration);
  const optionsError = useSelector(optionsSelectors.getOptionsErrorState);
  const optionsLoading = useSelector(optionsSelectors.getOptionsLoadingState);
  const configurationLoading = useSelector(currentDealSelectors.getLoadingStatus);
  const carImages: IImage[] = carConfig ? extractSliderImages(carConfig) : [];
  const { marketingLabel } = useSelector(getVariantDetails) || {};
  const { modelYear, model, title: variant, exteriorColour } = carConfig || {};
  const isMobile = useIsMobile();
  const alt = `${modelYear} ${model?.make} ${model?.title} ${variant} ${exteriorColour?.title}`;
  const selectedSection = useSelector(getCustomiseSelectedSection);

  return (
    <>
      {carImages?.length > 0 && (
        <VariantSlider
          images={carImages}
          error={optionsError}
          loading={optionsLoading || configurationLoading}
          alt={alt}
          selectedSection={selectedSection}
          interiorImageType={ImageType.INTERIOR}
          titleComponent={<SliderTitleOfferContainer />}
        />
      )}
      {isMobile && (
        <Box display={'flex'} justifyContent={'center'} flexDirection={'row'}>
          <MarketingLabel content={marketingLabel} inline={false} data-test={'text:marketing_label'} />
        </Box>
      )}
    </>
  );
};

export default VariantSliderContainer;
